import config from "@config"
import shareImg from "@imagesgz/share-logo.png"
import Footer from "@src/components/pages/guangzhou/footer"
import Goods from "@src/components/pages/guangzhou/goods"
import Guests from "@src/components/pages/guangzhou/guests"
import Head from "@src/components/pages/guangzhou/head"
import Intro from "@src/components/pages/guangzhou/intro"
import Play from "@src/components/pages/guangzhou/play"
import Stage from "@src/components/pages/guangzhou/stage"
import SEO from "@src/components/seo"
import { share as wechatShare } from "@src/utils/wechat"
import React, { useEffect } from "react"
import "./guangzhou.module.scss"

const title = "【正式开票】核聚变2021 Tour广州站，我们来了"
const desc = "11月20日、21日，我们不见不散"
const GuangzhouPage = () => {
  useEffect(() => {
    wechatShare({
      title,
      desc,
      link: `${config.pageUrl}/guangzhou`,
      imgUrl: `${config.cdnUrl}/${shareImg}`,
    })

    const list = window.document.documentElement.classList
    list.add("theme-gz")
    return () => {
      list.remove("theme-gz")
    }
  }, [])
  return (
    <>
      <SEO title={title} description={desc} />
      <Head />
      <Intro />
      <Play />
      <Stage />
      <Guests />
      <Goods />
      <Footer />
    </>
  )
}

export default GuangzhouPage
